import { useQuery } from '@tanstack/react-query';
import { type EcommRevenueBreakdownParams, type EcommRevenueBreakdownItem, fetchEcommRevenueBreakdown } from '../services/ecommRevenueBreakdownService';

export function useEcommRevenueBreakdown(params: EcommRevenueBreakdownParams) {
  return useQuery<EcommRevenueBreakdownItem[], Error>({
    queryKey: ['ecomm-revenueBreakdown', params],
    queryFn: () => fetchEcommRevenueBreakdown(params),
    staleTime: 1000 * 60 * 5,
    enabled: !!params.start_date && !!params.end_date,
  });
}
